import {
  Box,
  Button,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import SaveIcon from '@mui/icons-material/Save'
import { getTimeInMillis } from '../../../../../utility/datetime'
import { useProcessContext } from '../../../../../store'
import { ACTIVITY_TYPES } from '../../../../../utility/constants'

const TableRowHeader = ({
  headerValue,
  columnsLength,
  index,
  style = {},
  columnWidth = '100%',
  allRowsWithHeaders = [],
  setAllValues,
  isSelectable = false,
  updateTableSequenceAndHeaders = async () => {},
  handleHeaderDelete = async () => {},
  disabled = false,
  allowTableHeaders,
}) => {
  const processContext = useProcessContext((state) => state.processContext)
  const activityType = processContext?.activityTemplate?.activity_type

  const [isEditable, setIsEditable] = useState(false)
  const [value, setValue] = useState('')

  const [rowOptionsAnchorEl, setRowOptionsAnchorEl] = useState(null)

  const handleRowOptionsClick = (event) => {
    if (!disabled) {
      setRowOptionsAnchorEl(event.currentTarget)
    }
  }

  const handleRowOptionsClose = () => {
    setRowOptionsAnchorEl(null)
  }

  useEffect(() => {
    setValue(headerValue)
  }, [headerValue])

  const handleOnChange = (e) => {
    if (!disabled) {
      setValue(e.target.value)
    } else {
      setIsEditable(false)
    }
  }

  const handleSaveHeader = async () => {
    if (!disabled) {
      let newAllRowsWithHeaders = allRowsWithHeaders.map((datum, i) => {
        if (i == index) {
          datum['header_value'] = value
        }
        return datum
      })
      setAllValues({ updatedAt: getTimeInMillis() })
      await updateTableSequenceAndHeaders(newAllRowsWithHeaders)
      setIsEditable(!isEditable)
    } else {
      setIsEditable(false)
    }
  }

  return (
    <TableRow style={style}>
      {activityType !== ACTIVITY_TYPES.REVIEW ? (
        <>
          <TableCell
            style={{
              fontWeight: 'bold',
              minWidth: isSelectable ? 83 : 46,
              backgroundColor: '#f0f0f0',
            }}
          >
            <MoreVertIcon onClick={handleRowOptionsClick} style={{ cursor: 'pointer' }} />

            <Menu
              anchorEl={rowOptionsAnchorEl}
              open={Boolean(rowOptionsAnchorEl)}
              onClose={handleRowOptionsClose}
            >
              <MenuItem
                sx={{ color: 'red', columnGap: '5px' }}
                onClick={() => {
                  handleHeaderDelete(index)
                  handleRowOptionsClose()
                }}
                disabled={!allowTableHeaders}
              >
                <DeleteOutlineIcon fontSize="small" />
                Delete
              </MenuItem>
            </Menu>
          </TableCell>
          <TableCell
            style={{
              backgroundColor: '#f0f0f0',
              minWidth: 60,
            }}
          >
            {isEditable ? (
              <div
                onClick={handleSaveHeader}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <Tooltip title="Save header">
                  <SaveIcon fontSize="small" style={{ cursor: 'pointer' }} />
                </Tooltip>
              </div>
            ) : (
              <>{index + 1}</>
            )}
          </TableCell>
        </>
      ) : (
        <TableCell
          style={{
            backgroundColor: '#f0f0f0',
          }}
        >
          {index + 1}
        </TableCell>
      )}

      <TableCell colSpan={columnsLength} style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
        <Box
          onClick={() => {
            if (!disabled && allowTableHeaders && activityType !== ACTIVITY_TYPES.REVIEW) {
              setIsEditable(true)
            }
          }}
          maxHeight={'39px'}
          minHeight={'39px'}
          minWidth={isSelectable ? columnWidth - 164.5 : columnWidth - 127.5}
          display={'flex'}
          flexWrap={'wrap'}
          overflow={'clip'}
          alignItems={'center'}
        >
          {!isEditable ? (
            <Tooltip title={value}>
              <Typography variant="subtitle2" sx={{ fontSize: 12 }}>
                {value}
              </Typography>
            </Tooltip>
          ) : (
            <>
              <TextField
                size="small"
                fullWidth
                color="primary"
                onChange={(e) => handleOnChange(e)}
                value={value}
              />
            </>
          )}
        </Box>
      </TableCell>
    </TableRow>
  )
}

export default TableRowHeader
